const LOCAL_STORAGE_EVENT_KEY = 'local-storage';

export default LOCAL_STORAGE_EVENT_KEY